import { Component } from 'react';
import TabSwitcher from './TabSwitcher';
import { getSettingTypeIcon } from '../global/utils';
import BoardsSettings from './BoardsSettings';
import GeneralSetting from './GeneralSetting';
import dataManager from './data-manager';


class SettingsView extends Component {
    constructor(props) {
        super(props);

        this.state = {
            tabsList: [],
            settingsList: [],
            data: {'boards': []},
            switchViewAction: this.props.switchViewAction ? this.props.switchViewAction : false,
            boardTypes: [],
        }

        this.moduleName = 'settings-view';
        this.createTabsList = this.createTabsList.bind(this);
        
    }

    componentDidMount() {
        this.fetchSettingsData();
    }

    fetchSettingsData() {
        const fetchInterval = 
        setInterval(() => {
            const settings = dataManager.getSettingsData();

            if ( settings.boards.length > 0 ) {                
                this.dataReceived(settings);
                clearInterval(fetchInterval);
            }

        }, 300);
    }

    dataReceived(settingsData=[]) {
        const settingsList = settingsData.list ? settingsData.list : [];
        const boardTypes = settingsData.boardTypes ? settingsData.boardTypes : [];

        this.setState({settingsList: settingsList });
        this.setState({ boardTypes: boardTypes })
        this.createTabsList(settingsList);
    }

    createTabsList(settingsList=[]) {
        const tabsList = [];
        
        settingsList.forEach(setting => {
            const contents = setting.contents ? setting.contents : []
            
            const tabItem = {
                title: setting.title,
                icon: getSettingTypeIcon(setting.type),
                component: this.renderSetting(setting, contents)
            };

            tabsList.push(tabItem);
        })

        this.setState({
            tabsList: tabsList
        });
    }

    renderSetting(setting={id: -1, type: 'Boards', title: 'Title'}, contents=[])  {
        const switchViewAction = this.state.switchViewAction;
        const boardTypes = this.state.boardTypes;
        const controller = setting.controller ? setting.controller : false

        switch(setting.type) {
            case 'Boards': 
                return <BoardsSettings 
                            key={setting.id} 
                            data={setting} 
                            contents={contents}
                            switchViewAction={switchViewAction}
                            boardTypes={ boardTypes }
                            controller={ controller }
                        />;
            default: 
                return <GeneralSetting 
                            key={setting.id} 
                            data={setting} 
                            contents={contents} 
                            list={ [{'title': 'Dark Mode', 'toggle': true}] }
                            switchViewAction={switchViewAction}
                        />
        }
    }

    render () {
        const tabList = this.state.tabsList;
        return (
            <div className={this.moduleName}>
                <TabSwitcher list={ tabList } modifier={ this.moduleName } />
            </div>
        );
    }
}

export default SettingsView;